module.exports = __webpack_public_path__ + "media/packs/images/flags/ES-dcaaca49bc4135792c9c714daa96fde7.svg";